import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const BrickIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M3 3C3 2.72386 3.22386 2.5 3.5 2.5H6.5C6.77614 2.5 7 2.72386 7 3V4H9V3C9 2.72386 9.22386 2.5 9.5 2.5H12.5C12.7761 2.5 13 2.72386 13 3V4H13.75C14.4404 4 15 4.55964 15 5.25V12.75C15 13.4404 14.4404 14 13.75 14H2.25C1.55964 14 1 13.4404 1 12.75V5.25C1 4.55964 1.55964 4 2.25 4H3V3ZM2.5 5.5V12.5H13.5V5.5H2.5Z"
		></path>
	</svg>
))
